import * as React from "react";
import { useCallback } from "react";
import usePermissions from "hooks/usePermissions";
import useHistory from "routing/useHistory";
import { STEP_READABLE_ACTION_TYPES } from "security-app/components/SecurityEvents/EventProcedures/plugin/StepList/StepActionsButton";
import StepActionButton from "./StepActionButton";
function StepGoToDashboard({ config, actionUrl }) {
  const { dashboard_id } = config;
  const { isPermitted } = usePermissions();
  const disabled = !isPermitted(`dashboards:read:${dashboard_id}`);
  const history = useHistory();
  const handleClick = useCallback(() => history.push(actionUrl), [history, actionUrl]);
  return /* @__PURE__ */ React.createElement(
    StepActionButton,
    {
      hint: disabled ? "You don't have access to see this dashboard" : void 0,
      title: STEP_READABLE_ACTION_TYPES.go_to_dashboard,
      onClick: disabled ? void 0 : handleClick,
      disabled
    }
  );
}
export default StepGoToDashboard;
